import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { PdAttendee, PdBulkRegistration } from '../../../dtos/pd.dto';
import { PdService } from '../../../services/pd/pd.service';
import { BulkRegistrationPayload } from '../../../types/responses/proforms.responses';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-pd-bulk-registration-modal',
  standalone: false,
  templateUrl: './pd-bulk-registration-modal.component.html',
  styleUrl: './pd-bulk-registration-modal.component.scss',
})
export class PdBulkRegistrationModalComponent {
  @ViewChild('modal') modal: ModalComponent;

  @ViewChild('emailForm', { static: true }) emailForm: NgForm;

  @Input() sessionId: number;

  @Output() readonly handleAttendees = new EventEmitter<PdAttendee[]>();

  isLoading = false;

  activeSection: 'form' | 'preview';

  emailRecipients = '';

  bulkResponse?: PdBulkRegistration;

  errorMessage: string;

  constructor(private pdService: PdService) {}

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.resetValues();
    this.resetForm();
    this.modal.close();
  }

  resetForm() {
    if (this.emailForm) {
      this.emailForm.resetForm();
    }
  }

  resetValues() {
    this.emailRecipients = '';
    this.errorMessage = '';
    this.bulkResponse = undefined;
  }

  submitForm() {
    this.isLoading = true;
    const bulkRegistrationPayload: BulkRegistrationPayload = {
      send_to: this.emailRecipients,
    };

    this.pdService
      .bulkRegisterSession(this.sessionId, bulkRegistrationPayload)
      .subscribe({
        next: (response) => {
          if (response) {
            this.bulkResponse = response;
            this.handleAttendeesAdded();
            this.resetForm();
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.errorMessage = error.message;
          if (error) {
            this.isLoading = false;
            this.resetForm();
            setTimeout(() => {
              this.errorMessage = '';
            }, 3000);
          }
        },
      });
  }

  handleAttendeesAdded() {
    if (
      this.bulkResponse?.attendees &&
      this.bulkResponse.attendees.length > 0
    ) {
      this.handleAttendees.next(this.bulkResponse.attendees);
    }
  }
}
